"use client";

import { useUtcMidnightCountdown } from "#/lib/utcCountdown";

export function NewMapsCountdown() {
  const countdown = useUtcMidnightCountdown();

  return (
    <>
      New maps in <span className="font-black tabular-nums">{countdown}</span>
    </>
  );
}
